import { FleekError } from './FleekError';

export class InvalidJSONFormat extends FleekError<void> {
  public name = 'InvalidJSONFormat';

  toString = () => `Invalid JSON format.`;
}
